import React, { useState, useRef, useEffect } from 'react';
import { Modal, Form, Button, Table, InputNumber, Select } from 'antd';
import { useParams } from 'react-router';
import Moment from 'moment';
import API from '../../../../services/API';

// Compliance-approved dispute reasons. Values are backend DisputeReason enum names;
// labels are the exact compliance-approved wording.
const DISPUTE_REASONS = [
  { value: 'UNAUTHORIZED', label: 'Unauthorized' },
  { value: 'DOUBLE_CHARGE', label: 'Double Charge' },
  { value: 'PAID_BY_OTHER_MEANS', label: 'Paid by Other Means' },
  { value: 'SUBSCRIPTION_CHARGE_AFTER_CANCELLATION_OR_DURING_TRIAL', label: 'Subscription Charge after Cancellation or During Trial Period' },
  { value: 'GOODS_OR_SERVICES_NOT_RECEIVED', label: 'Goods or Services Not Received' },
  { value: 'GOODS_OR_SERVICES_NOT_AS_DESCRIBED', label: 'Goods or Services Not as Described' },
  { value: 'OVERCHARGE', label: 'Overcharge' },
];

export default function VoidTransactionsModal({ creditCardTransactions, refreshList }) {

  const formRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalLoading, showModalLoading] = useState(false);
  const [voidedAmount, setVoidedAmount] = useState(0);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [amountValues, setAmountValues] = useState({});
  const [disputeReason, setDisputeReason] = useState(null);
  
  const transactionDetails = creditCardTransactions;

  let { userId } = useParams();

  const showModal = () => {
    setIsModalOpen(true);
  };

  const voidTransactions = (data) => {
    console.log('void transactions', data);
    showModalLoading(true);

    const requestData = {
      userId,
      disputeReason
    };

    requestData.transactionsToVoid = selectedKeys.map((key) => {
      return {
        transactionId: key,
        voidedAmountInCents: amountValues[key] ?? transactions.filter((row) => row.transactionId === key)[0].amountInCents
      }
    });
    const request = API.postVoidTransactions(requestData);

    request.then((resp) => {
      showModalLoading(false);
      setIsModalOpen(false);
      setDisputeReason(null);
      alert(resp?.message || 'Transactions voided.')
      if (refreshList) refreshList();
    }).catch((error) => {
      alert(error?.message || 'Something went wrong')
      showModalLoading(false);
    });
  };

  const cancelVoid = () => {
    formRef.current?.resetFields();
    setDisputeReason(null);
    setIsModalOpen(false);
  };

  const onFinish = (data) => {
    voidTransactions(data);
  };

  const handleAmountChange = (record, val) => {
    const newAmountValues = { ...amountValues };
    newAmountValues[record.key] = val;
    setAmountValues(newAmountValues);
  }

  useEffect(() => {
    let voidedCalculated = 0;
    selectedKeys.map((key) => {
      voidedCalculated += amountValues[key] ?? transactions.filter((row) => row.transactionId === key)[0].amountInCents ?? 0;
    });
    setVoidedAmount(voidedCalculated);
  }, [selectedKeys, amountValues]);

  useEffect(() => {
    if (transactionDetails?.length > 0) {
      setTransactions(transactionDetails.filter((row) => row.status === 'SETTLED' && row.transactionType === 'CREDIT'));
    }

  }, [transactionDetails]);

  const onFinishFailed = (error) => {
    console.log('new error', { ... error});
  };

  const data = transactions.map((transaction) => {
    return {
      key: transaction.transactionId,
      id: transaction.transactionId,
      amountInCents: transaction.amountInCents,
      amount: transaction.amount,
      date: Moment(transaction.transactionDate).format('MM-DD-YYYY'),
      descriptor: transaction.descriptor,
    };
  });

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      console.log(`selectedRowKeys: ${selectedRowKeys}`, selectedRowKeys, 'selectedRows: ', selectedRows, formRef.current);
      setSelectedKeys(selectedRowKeys);
    },
    getCheckboxProps: (record) => ({
      disabled: false,
      // Column configuration not to be checked
      name: record.key,
    }),
  };

  return (
    <>
      <Button type="danger" ghost onClick={showModal} className={'card-bottom-buttons'}>
        Dispute Transactions
      </Button>
      <Modal title={"Dispute Transactions"} open={isModalOpen} footer={null} onCancel={() => setIsModalOpen(false)}>
        <Form
          name="basic"
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 16,
          }}
          style={{
            maxWidth: 600,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          ref={formRef}
        >
          <div style={{ marginBottom: 16 }}>
            <label>Dispute Reason: </label>
            <Select
              placeholder="Select Dispute Reason"
              value={disputeReason}
              onSelect={(value) => setDisputeReason(value)}
              style={{ minWidth: 300 }}
            >
              {DISPUTE_REASONS.map((reason) => (
                <Select.Option key={reason.value} value={reason.value}>
                  {reason.label}
                </Select.Option>
              ))}
            </Select>
          </div>
          <div>
            <Table rowSelection={{
                type: 'checkbox',
                ...rowSelection,
              }} dataSource={data}>
              <Table.Column
                title="Merchant"
                dataIndex="descriptor"
                key="descriptor"
              />
              <Table.Column
                title="Amount"
                dataIndex="amount"
                key="amount"
                render={(amount, record) => (
                  <>
                    { selectedKeys && selectedKeys.indexOf(record.key) > -1
                      ? (<><InputNumber defaultValue={record.amountInCents} min="0" max={record.amountInCents} onChange={(val) => handleAmountChange(record, val)}/> &#162;</>)
                      : <span>{amount}</span> }
                  </>
                )}
              />
              <Table.Column
                title="Date"
                dataIndex="date"
                key="date"
              />
            </Table>
          </div>
          <hr />
          <div style={{textAlign: 'center'}}>
            <label>Total Amount Voided <small>(cents)</small>:</label> {voidedAmount}&#162;
          </div>
          <hr />
          <div>
            <Form.Item >
              <Button type="primary" htmlType="submit" disabled={modalLoading
                || (selectedKeys.length === 0)
                || !disputeReason}>
                Submit
              </Button>
              &nbsp;
              <Button htmlType="button" onClick={cancelVoid} disabled={modalLoading}>
                Cancel
              </Button>
            </Form.Item>
          </div>
        </Form>
      </Modal>
    </>
  );
}